import React, { Component } from 'react'
import { Link } from 'react-router-dom'
import SessionRow from '../Sessions/SessionRow.js'
import UserRow from './UserRow.js'
import BusinessCardExchange from './BusinessCardExchange.js'
import getLabel from '../../utilities/label.js'
import TitleBar from '../TitleBar'
import NoteForm from '../NoteForm'
import initializeHelperText from '../../utilities/helperText.js'
import './users.css'
import _ from 'lodash'

export default class UserProfile extends Component {
  constructor(props) {
    super(props)
    const givenStatus = props.location &&
      props.location.state
    const noteTakingStatus = givenStatus ?
      props.location.state.noteTakingStatus :
      false
    const activeTab = givenStatus ?
      props.location.state.activeTab :
      'attendees'
    const user = this.getUser(props.match.params.id)
    this.state = {
      user: user,
      isTakingNotes: noteTakingStatus,
      goBackToNoteIndex: noteTakingStatus
    }
    this.toggleNote = this.toggleNote.bind(this)
    props.setActiveTab(activeTab, false)
    window.trackPage('ProfileUserScreen', props.match.params.id)
  }

  componentDidMount() {
    // scroll to top
    window.scrollTo(0,0)
    initializeHelperText()
  }

  getUser(id) {
    return _.find(this.props.users.event_users, {id: parseInt(id, 10)})
  }

  toggleNote(){
    // if you came from the notes index go back to the notes index and toggle state.isTakingNotes
    if (this.state.goBackToNoteIndex) {
      this.props.history.push('/notes')
      this.setState({
        isTakingNotes: !this.state.isTakingNotes
      })
      // otherwise show this component again
    } else {
      this.setState({
        isTakingNotes: !this.state.isTakingNotes
      })
    }
  }

  getSpeakerSessions(){
    const sessions = []
    _.each(this.props.sessions.sessions, (session) => {
      let speakerUsersIds = _.map(session.event_session_speakers, function(speaker) {return speaker.user_id})
      if(speakerUsersIds.indexOf(this.state.user.user_id) > -1){
        sessions.push(
          <div key={session.id}>
            <div className="display-date">{session.formatted_display_date}</div>
            <SessionRow session={session} postResource={ this.props.postResource } flashMessage={ this.props.flashMessage }/>
          </div>
        )
      }
    })
    const header = <h3 className='teal'>{ getLabel('session_speaker_at') }</h3>
    sessions.length && sessions.unshift(header)
    return sessions
  }

  getSendMessageButton(user){
    // let currentUserBlocksMessages = (_.find(this.props.users.event_users, {user_id: window.currentUser.user_id})).block_messages
    // first check if currentUser has messages blocked
    // if(this.state.user.block_messages) {
    //   return <div className='disabled-send'>
    //     <button disabled className='disabled-send'>
    //       <i className="fa fa-envelope-o"></i>  { getLabel('send_message') }
    //       <i className='fa fa-question helper-text' data-content="This user's messages have been disabled." rel='popover' data-placement='bottom' data-trigger='hover'></i>
    //     </button>
    //     <br></br>
    //   </div>
    // } if(currentUserBlocksMessages){
    //   return <div className='disabled-send'>
    //     <button disabled className='disabled-send'>
    //       <i className="fa fa-envelope-o"></i>  { getLabel('send_message') }
    //       <i className='fa fa-question helper-text' data-content="Your messages have been disabled." rel='popover' data-placement='bottom' data-trigger='hover'></i>
    //     </button>
    //     <br></br>
    //   </div>
    // } else {
    return <div>
      <Link
        to={'/message/' + user.user_id }>
        <button className='send-message'>
          <i className="fa fa-envelope-o"></i> { getLabel('send_message') }
        </button>
      </Link>
      <br></br>
    </div>
    // }
  }

  render() {
    const {
      isTakingNotes,
      user } = this.state
    const backButton = '<i class=\'fa fa-arrow-left\'></i> ' + getLabel('back_button')
    if(!user) {
      return (
        <div><a onClick={() => window.history.back()}>back</a><div>User not found.</div></div>
      )
    }
    if(!isTakingNotes) {
      return (
        <div>
          <TitleBar
            title={ user.first_name + ' ' + user.last_name }
            leftButtonLabel={ backButton }
            leftButtonAction={ () => window.history.back() } />
          <div className='user-profile'>
            <UserRow
              user={ user }
              link={ false }
              skipEllipsis={ true }
              hideIcons={ true } />
            <div className='user-actions'>
              { this.getSendMessageButton(user) }
              <button
                className={'note ' + (user.note_on_user ? 'active-button' : '') }
                onClick={ this.toggleNote } >
                <i className="fa fa-sticky-note-o"></i>  { getLabel('note') }
              </button>
              <BusinessCardExchange user={ user } />
            </div>
            <div className='user-bio'>
              <span className='blue-header'>
                <h4>{ getLabel('bio') }</h4>
              </span>
              { user.bio &&
                <p dangerouslySetInnerHTML={{__html: user.bio}} ></p>
              }
              { !user.bio &&
                <span className="no-bio">{ getLabel('not_provided_bio') }</span>
              }
            </div>
            { user.is_speaker && this.getSpeakerSessions() }
            <pre className="debug-json">{JSON.stringify(user, false, 2)}</pre>
          </div>
        </div>
      )
    } else {
      return (
        <NoteForm
          postResource={ this.props.postResource }
          note={ user.note_on_user }
          user={ user }
          toggleNote={ this.toggleNote }
          postData={{ event_user_id: user.id }}
          noteType={ 'userNote' }
          flashMessage={ this.props.flashMessage } >
          <UserRow
            user={ user }
            link={ false }
            hideIcons={ true }
            action={ this.toggleNote }
          />
        </NoteForm>
      )
    }
  }
}
